'use strict';

require('./KayleeService');
require('./RoomService');
var defaults = require('../../defaults/Defaults');
var sutl = require('../../sutl/Sutl');

angular.module('inara').factory('HandRaiseService', HandRaiseService);

HandRaiseService.$inject = [ '$interval', '$timeout', 'KayleeService', 'RoomService' ];

//                       | hand raised                          | hand lowered
//                       v                                      v
//
// handRaised:           ----------------------------------------
//                       |                                      |
//                 -------                                      ---------------
//
// highlightState:       ----  ----  ----  ----------------------
//                       |  |  |  |  |  |  |                    |
//                 -------  ----  ----  ----                    ---------------
//
// flashState:           ----  ----  ----
//                       |  |  |  |  |  |
//                 -------  ----  ----  ---------------------------------------
//
// isFlashing:           -------------------
//                       |                 |
//                 -------                 ------------------------------------

function HandRaiseService($interval, $timeout, KayleeService, RoomService) {
    var flashCount = 0;
    var flashNumCycles = 7;
    var flashTimeOffMs = 500;
    var flashTimeOnMs = 1000;
    var flashTimeout = null;
    var flashState = false;
    var flashStateObserverId = 0;
    var flashStateObservers = [];
    var handRaiseParticipants = {}; // handRaiseParticipants[callId][participantId] = timestamp
    var mostRecentCallId = null;
    var mostRecentParticipantId = null;
    var mostRecentParticipantTimestamp = null;

    init();

    return {
        flashState: getFlashState,
        highlightState: getHighlightState,
        isAnyHandRaised: isAnyHandRaised,
        isAnyHandRaisedInCall: isAnyHandRaisedInCall,
        isFlashing: isFlashing,
        isParticipantHandRaised: isParticipantHandRaised,
        participantFlashState: getParticipantFlashState,
        participantHandRaiseTimestamp: getParticipantHandRaiseTimestamp,
        participantHighlightState: getParticipantHighlightState,
        subscribeFlashState: subscribeFlashState,
    };

    function getFlashState() {
        return flashState;
    }

    function getHighlightState() {
        if (flashTimeout === null) {
            return isAnyHandRaised();
        } else {
            return flashState;
        }
    }

    function getParticipantFlashState(callId, participantId) {
        if (
            callId === mostRecentCallId &&
            participantId === mostRecentParticipantId &&
            flashTimeout !== null
        ) {
            return flashState;
        }

        return false;
    }

    function getParticipantHandRaiseTimestamp(callId, participantId) {
        return sutl.getProp(handRaiseParticipants, [callId, participantId], 0);
    }

    function getParticipantHighlightState(callId, participantId) {
        if (
            callId === mostRecentCallId &&
            participantId === mostRecentParticipantId &&
            flashTimeout !== null
        ) {
            return flashState;
        }

        return isParticipantHandRaised(callId, participantId);
    }

    function init() {
        RoomService.onOnlineChanged(onRoomOnlineChanged);
    }

    function isAnyHandRaised() {
        return Object.keys(handRaiseParticipants).length > 0;
    }

    function isAnyHandRaisedInCall(callId) {
        return handRaiseParticipants.hasOwnProperty(callId);
    }

    function isFlashing() {
        return flashTimeout !== null;
    }

    function isParticipantHandRaised(callId, participantId) {
        return sutl.getProp(handRaiseParticipants, [callId, participantId]) !== undefined;
    }

    function onCallAdded(callId) {
        if (!RoomService.online()) return;
        var call = RoomService.getRoom().$getCalls(defaults.inara.numRecentCalls).$recordAt(callId);
        var participants = call.$getParticipants();

        participants.$onChildAdded(onCallParticipantChanged);
        participants.$onChildChanged(onCallParticipantChanged);
        participants.$onChildRemoved(onCallParticipantRemoved);

        function onCallParticipantChanged(participantId) {
            var participant = participants.$recordAt(participantId);

            if (participant.isHandRaised) {
                sutl.setProp(handRaiseParticipants, [callId, participantId], true);
                updateFlashing();
            } else {
                onCallParticipantRemoved(participantId);
            }
        }

        function onCallParticipantRemoved(participantId) {
            if (handRaiseParticipants[callId]) {
                delete handRaiseParticipants[callId][participantId];

                if (Object.keys(handRaiseParticipants[callId]).length <= 0) {
                    delete handRaiseParticipants[callId];
                }
            }

            updateFlashing();
        }
    }

    function onCallRemoved(callId) {
        delete handRaiseParticipants[callId];
        updateFlashing();
    }

    function updateFlashing() {
        var prevMostRecentParticipantTimestamp = mostRecentParticipantTimestamp;

        mostRecentCallId = null;
        mostRecentParticipantId = null;
        mostRecentParticipantTimestamp = 0;

        for (var callId in handRaiseParticipants) {
            if (!handRaiseParticipants.hasOwnProperty(callId)) continue;
            var callParticipants = handRaiseParticipants[callId];

            for (var participantId in callParticipants) {
                if (!callParticipants.hasOwnProperty(participantId)) continue;

                var timestamp = callParticipants[participantId];

                if (timestamp >= mostRecentParticipantTimestamp) {
                    mostRecentCallId = callId;
                    mostRecentParticipantId = participantId;
                    mostRecentParticipantTimestamp = timestamp;
                }
            }
        }

        if (
            mostRecentParticipantId === null ||
            mostRecentParticipantTimestamp < prevMostRecentParticipantTimestamp
        ) {
            // stop flashing

            if (flashTimeout !== null) {
                $timeout.cancel(flashTimeout);
                flashTimeout = null;
            }

            flashCount = 0;
            updateFlashState(false);
        } else if (mostRecentParticipantTimestamp > prevMostRecentParticipantTimestamp) {

            if (flashTimeout === null) {
                // start flashing

                flashCount = 0;
                flashTimeout = $timeout(onFlash, flashTimeOnMs);
                updateFlashState(true);
            } else {
                // reset flashing
                flashCount = flashState ? 0 : 1;
            }
        }
    }

    function onFlash() {
        if (!RoomService.online()) {
            resetStates();
            return;
        }

        updateFlashState(!flashState);
        flashCount++;

        if (flashCount >= 2 * flashNumCycles - 1) {
            flashCount = 0;
            flashTimeout = null;
        } else {
            flashTimeout = $timeout(onFlash, flashState ? flashTimeOnMs : flashTimeOffMs);
        }
    }

    function onRoomOnlineChanged(isOnline) {
        if (isOnline) {
            var calls = RoomService.getRoom().$getCalls(defaults.inara.numRecentCalls);
            calls.$onChildAdded(onCallAdded);
            calls.$onChildRemoved(onCallRemoved);
        } else {
            resetStates();
        }
    }

    function resetStates() {
        flashCount = 0;
        if (flashTimeout) $timeout.cancel(flashTimeout);
        flashTimeout = null;
        updateFlashState(false);
        handRaiseParticipants = {};
        mostRecentCallId = null;
        mostRecentParticipantId = null;
        mostRecentParticipantTimestamp = 0;
    }

    function subscribeFlashState(callback) {
        var id = (flashStateObserverId++).toString();

        flashStateObservers.push({
            id: id,
            callback: callback,
        });

        callback(flashState);

        return { unsubscribe: function() { unsubscribeFlashState(id); } };
    }

    function unsubscribeFlashState(id) {
        for (var i = 0; i < flashStateObservers.length; i++) {
            var observer = flashStateObservers[i];
            if (observer.id === id) {
                flashStateObservers.splice(i, 1);
                return;
            }
        }
    }

    function updateFlashState(newFlashState) {
        if (newFlashState === flashState) return;
        flashState = newFlashState;

        for (var i = 0; i < flashStateObservers.length; i++) {
            flashStateObservers[i].callback(flashState);
        }
    }
}

module.exports = HandRaiseService;
